/* @generated from adl module ferovinum.sourcecontracts.invoicestatusevent */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.invoice_status_event` contract.
 */
export interface InvoiceStatusEventSource {
  id: ferovinum_app_db.InvoiceStatusEventId;
  invoiceId: ferovinum_app_db.InvoiceId;
  status: common_strings.StringNE;
  transitionedAt: common.Instant;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeInvoiceStatusEventSource(
  input: {
    id: ferovinum_app_db.InvoiceStatusEventId,
    invoiceId: ferovinum_app_db.InvoiceId,
    status: common_strings.StringNE,
    transitionedAt: common.Instant,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): InvoiceStatusEventSource {
  return {
    id: input.id,
    invoiceId: input.invoiceId,
    status: input.status,
    transitionedAt: input.transitionedAt,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const InvoiceStatusEventSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.invoicestatusevent","decl":{"annotations":[{"value":{"modelName":"source__app_db.invoice_status_event","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":["notes","user_id"],"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"UnpublishedColumns"}},{"value":"The published `source__app_db.invoice_status_event` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceStatusEventId"}},"parameters":[]}},{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"transitionedAt","default":{"kind":"nothing"},"name":"transitionedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"InvoiceStatusEventSource","version":{"kind":"nothing"}}};

export const snInvoiceStatusEventSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.invoicestatusevent", name:"InvoiceStatusEventSource"};

export function texprInvoiceStatusEventSource(): ADL.ATypeExpr<InvoiceStatusEventSource> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceStatusEventSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.invoicestatusevent.InvoiceStatusEventSource" : InvoiceStatusEventSource_AST
};
